import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../Redux Store/actions';

//*MUI
import { Box, Divider, Tooltip } from '@mui/material';

//*files
import cssClasses from './EventCp.module.css';
import {
  getAllCpForEvents,
  getAllUsersForEvents,
  getEventByEventName,
} from '../../../Services/Event';
import { uniqBy } from 'lodash';
import EventSalesIcon from '../../../Assets/Images/Common/noProjectFound.svg';
import EventCpIcon from '../../../Assets/Images/Common/NoChannelPartnersfound.svg';
import { DataGrid } from '@mui/x-data-grid';


const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },

  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};

function EventCp() {
  const dispatch = useDispatch();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const { eventID } = useParams();
  const [AllCpData, setAllCpData] = useState([]);

  const [pageNumber, setPageNumber] = useState(0);
  const [pageUserNumber, setPageUserNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [TotalCount , setTotalCount] = useState(0);

  const [EventName, setEventName] = useState('');
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageUserMaintain, setPageUserMaintain] = useState(0);
  const [NoCpFound, setNoCpFound] = useState(null);

  useEffect(() => {
    dispatch(action.activeMenu('eventcp'));
    getEventName();
  }, []);

  useEffect(() => {
    console.log('Event-Name', eventID);
    getEvent(0,false);
  }, [eventID]);

  const CpColumns = [
    {
      field: 'BillingName',
      headerName: 'Billing Name',
      width: 280,
    },
    {
      field: 'DisplayID',
      headerName: 'Display ID',
      width: 150,
    },
    {
      field: 'ContactPerson',
      headerName: 'Name',
      width: 290,
    },
    {
      field: 'Email',
      headerName: 'Email',
      width: 290,
    },
    {
      field: 'MobileNumber',
      headerName: 'Mobile Number',
      width: 190,
    },
  ];

  function getEventName() {
    getEventByEventName(eventID).then((response) => {
      console.log('Event-Name', response[0].title);
      setEventName(response);
    });
  }

  function getEvent(pageNumber,merge) {
    getAllCpForEvents(
      eventID,
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1
    )
      .then((resp) => {
        console.log('Cp-data', resp);
        if (resp) {
          let result = [];
          resp.data
            .filter((f) => f.LaunchCpRelations?.length)
            .forEach((element) => {
              element = element.LaunchCpRelations;
              element.forEach((ele) => {
                let obj1 = flatObject(ele);
                let obj2 = { ...obj1 };
                delete obj2.CP;
                obj2 = { ...obj2, ...obj1.CP };
                result.push(obj2);
                console.log('-------->', result);
              });
            });
          console.log('Cp-result: ', result);
          let uniqResult = uniqBy(result, 'cpId').filter(
            // A CP mid-Profile-Update is still a normal approved CP -- just
            // temporarily flagged for self-edit -- so it stays selectable here.
            (f) => f.approvalStatus === 'approved' || f.approvalStatus === 'Profile Update'
          );
          console.log('uniqResult: ', uniqResult);
          setTotalCount(uniqResult.length)
          if (uniqResult.length > 0) {
            setNoCpFound(true);
          } else {
            setNoCpFound(false);
          }

          const CpData = uniqResult?.map((el, index) => ({
            key: `${el}_${index}`,
            id: el?.cpId,
            index: index,
            BillingName: el?.billingName,
            DisplayID: el?.cpDisplayId,
            ContactPerson: el?.CpContactPerson[0].name,
            Email: el?.CpContactPerson[0].email,
            MobileNumber: el?.CpContactPerson[0].contactNumber,
          }));

          if (merge) {
            setAllCpData((pre) => [...pre, ...CpData]);
          } else {
            setAllCpData([...CpData]);
          }
        }
      })
      .catch((err) => {
        console.log('Cp-Data', err);
      });
  }

  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getEvent(passPageNumber,true);
  }

  return (
    <Box className={cssClasses.Container}>
      <Box mb={2} padding={'0 2.4rem'}>
        <Box className={cssClasses.HeaderTitle}>{EventName[0]?.title}</Box>
        <Tooltip title={<h1> {EventName[0]?.description}</h1>}>
          <Box
            className={cssClasses.SubTitle}
            width={'70%'}
            overflow={'hidden'}
            textOverflow={'ellipsis'}
            whiteSpace={'nowrap'}
          >
            {EventName[0]?.description}
          </Box>
        </Tooltip>
      </Box>

      <Divider variant='middle' />

      <Box overflow={'auto'} height={'100%'}>
        {NoCpFound === true && (
          <>
            <Box
              className={cssClasses.FlexRow}
              marginTop={'2rem'}
              padding={'0 2.4rem'}
            >
              <Box className={cssClasses.SubHeaderTitle}>{TotalCount} Channel Partners</Box>
            </Box>
            {loggedInUser?.roleId?.accessibleTabs?.Event['View Details']?.CP
              ?.isAccessible && (
              <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
                {/* <Datagrid
            rows={AllCpData}
            columns={CpColumns}
            hideFooter={false}
          /> */}

                <DataGrid
                  rows={AllCpData}
                  columns={CpColumns}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                  page={pageMaintain}
                  onPageChange={(_page) => {
                    console.log(_page);
                    setPageMaintain(_page);
                    if (pageNumber < _page) {
                      getMoreData(_page);
                      // setPageNumber(_page);
                    }
                  }}
                  sx={[dataGridStyles]}
                />
              </Box>
            )}
          </>
        )}

        {NoCpFound === false && (
          <Box mt={2}>
            <Box width={'100%'} height={'100%'}>
              <Box className={cssClasses.noDataMsg}>
                <Box className={cssClasses.emptyIcon}>
                  <img src={EventCpIcon} alt='No channel partners were found' />
                </Box>
                <Box className={cssClasses.emptyTitle}>
                  No channel partners were found
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default EventCp;

function flatObject(obj) {
  var newObj = {};
  for (var key in obj) {
    if (typeof obj[key] === 'object') {
      for (var subKey in obj[key]) {
        newObj[subKey] = obj[key][subKey];
      }
    } else {
      newObj[key] = obj[key];
    }
  }
  return newObj;
}
